import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Location, useLocation } from 'react-router-dom';

import { Loading } from '@portal/common/components';

import { resetDataTool } from '../../store/data-explorer/actions';
import { getDataToolConfig } from '../../store/data-explorer/selectors';
import { RouterState } from '../../store/router/reducer';
import { getRouter } from '../../store/router/selectors';
import usePrevious from '../hook/use-previous';

const withLocationSyncCheck = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
    const HOC: React.FC<P> = (props) => {
        const location = useLocation();
        const reduxLocation = useSelector(getRouter);
        const dataToolConfig = useSelector(getDataToolConfig);
        const prevReduxLocation = usePrevious(reduxLocation);
        const dispatch = useDispatch();

        const isEqual = (source: Location<any> | RouterState, target: RouterState) =>
            source.pathname === target.pathname &&
            source.search === target.search &&
            source.hash === target.hash;

        const [isSynced, setIsSynced] = React.useState(isEqual(location, reduxLocation));

        useEffect(() => {
            const isSynced = isEqual(location, reduxLocation);
            if (isSynced && prevReduxLocation && !isEqual(prevReduxLocation, reduxLocation)) {
                dispatch(resetDataTool(dataToolConfig));
            }
            setIsSynced(isSynced);
        }, [location, reduxLocation]);

        if (!isSynced) {
            return <Loading />;
        }

        return <WrappedComponent {...props} />;
    };

    return HOC;
};

export default withLocationSyncCheck;
